import { useCallback, useMemo } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { PROMPT_ACTION } from 'src/data/prompt';
import * as events from 'src/lib/events';

export const useEvents = ({ onAction }) => {
  const trackSearchSubmitted = useCallback(
    ({ searchTerm, tagsFilters, typeFilters }) => {
      onAction(PROMPT_ACTION.trackEvent, {
        event: events.PROMPTS.promptsResourceSearchSubmitted,
        term: searchTerm,
        tagsFilters: tagsFilters.join(', '),
        typeFilters: typeFilters.join(', '),
      });
    },
    [onAction]
  );

  const trackSearchSubmittedDebounced = useDebouncedCallback(trackSearchSubmitted, 1000);

  return useMemo(
    () => ({
      trackSearchSubmitted,
      trackSearchSubmittedDebounced,
    }),
    [trackSearchSubmitted, trackSearchSubmittedDebounced]
  );
};
